import { IFarms } from "../../@types/API/IFarm";
import { ICoords } from "../../@types/GoogleMaps/ICoord";

type ICustomFarm = {
  id: string;
  initials: string;
  coords: ICoords;
  name: string;
  bgColor: string;
};

export function getFarmsAsOptions(farms: IFarms) {

  return farms.map((farm) => ({
    label: `${farm.name}`,
    value: farm.id,
    info: { id: farm.id, initials: farm.initials, name: farm.name, coords: farm.map_coords } as ICustomFarm
  }));
}
